import BikeFinder from "src/components/BikeFinder/BikeFinder";
import MainLayout from "src/components/Layout/MainLayout";
import React from "react";
import SeoHead from "src/components/Seo/SeoHead";
import useTranslation from "next-translate/useTranslation";

const Page = () => {
  const { t } = useTranslation("ebikeFinder");

  return (
    <MainLayout>
      <SeoHead
        title={t("bikeFinderTitle")}
        description={t("bikeFinderDescription")}
        keywords={t("bikeFinderKeywords")}
        ogImage="/images/The-Cycleverse-OpenGraph-Die-bestenE-Bikes.png"
        ogDescription={t("bikeFinderDescription")}
      >
        <script async src="https://static.landbot.io/landbot-3/landbot-3.0.0.js"></script>
      </SeoHead>

      <BikeFinder
        translationsNamespace="ebikeFinder"
        flavor="ebike"
        landbotUrl="https://chats.landbot.io/v3/H-818493-U3SIPLLJFHTPUVMC/index.json"
        content={
          <React.Fragment>
            <h2 data-test="page-welches-ebike-passt-zu-mir">{t("bikeFinderSec1Headline")}</h2>
            <p>{t("bikeFinderSec1Text1")}</p>
            <p>{t("bikeFinderSec1Text2")}</p>
            <p>{t("bikeFinderSec1Text3")}</p>
            <h2>{t("bikeFinderSec2Headline")}</h2>
            <p>{t("bikeFinderSec2Text1")}</p>
            <p>{t("bikeFinderSec2Text2")}</p>
            <p>{t("bikeFinderSec2Text3")}</p>
            <p>{t("bikeFinderSec2Text4")}</p>
            <p>{t("bikeFinderSec2Text5")}</p>
            <p>{t("bikeFinderSec2Text6")}</p>
            <h2>{t("bikeFinderSec3Headline")}</h2>
            <p>{t("bikeFinderSec3Text1")}</p>
            <h2>{t("bikeFinderSec4Headline")}</h2>
            <p>{t("bikeFinderSec4Text1")}</p>
            <p>{t("bikeFinderSec4Text2")}</p>
            <h2>{t("bikeFinderSec5Headline")}</h2>
            <p>{t("bikeFinderSec5Text1")}</p>
            <p>{t("bikeFinderSec5Text2")}</p>
            <h2>{t("bikeFinderSec6Headline")}</h2>
            <p>{t("bikeFinderSec6Text1")}</p>
            <p>{t("bikeFinderSec6Text2")}</p>
            <h2>{t("bikeFinderSec7Headline")}</h2>
            <p>{t("bikeFinderSec7Text1")}</p>
            <h2>{t("bikeFinderSec8Headline")}</h2>
            <p>{t("bikeFinderSec8Text1")}</p>
            <h2>{t("bikeFinderSec9Headline")}</h2>
            <p>{t("bikeFinderSec9Text1")}</p>
            <h2>{t("bikeFinderSec10Headline")}</h2>
            <p>{t("bikeFinderSec10Text1")}</p>
            <h2>{t("bikeFinderSec11Headline")}</h2>
            <p>{t("bikeFinderSec11Text1")}</p>
            <p>{t("bikeFinderSec11Text2")}</p>
            <h2>{t("bikeFinderSec12Headline")}</h2>
            <p>{t("bikeFinderSec12Text1")}</p>
            <p>{t("bikeFinderSec12Text2")}</p>
            <h2>{t("bikeFinderSec13Headline")}</h2>
            <p>{t("bikeFinderSec13Text1")}</p>
            <h2>{t("bikeFinderSec14Headline")}</h2>
            <p>{t("bikeFinderSec14Text1")}</p>
          </React.Fragment>
        }
      />
    </MainLayout>
  );
};

export default Page;
